export const EL_DIALOG_INNER_CONTENT = 'el-dialog-inner-content';
